// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hy","advertCardHeader__actions":"c-a_hz","advertCardHeader__bottomLabel":"c-a_hA"};